import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  rootAppTable: {
    position: 'relative',
    height: "100%",
    backgroundColor: "#fff",
    "& .loading": {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.1)",
      zIndex: "99",
      display: "flex",
      "& > *": {
        margin: "auto"
      }
    },
    "& .t-footer": {
      width: '100%',
      display: 'flex',
      paddingTop: 4,
      
      "& .f-left": {
        flex: '1',
        display: 'flex',
        "& .l-page": {
          display: "flex",
          marginRight: "20px",
          // padding: "5px 0px",
          "& >*": {
            margin: "auto",
            marginLeft: "5px"
          }
        },
      },
      "& .f-right": {
        display: 'flex',
        // margin: "7px 0",
        height: "40px",
        "& .r-page": {
          display: "flex",
          marginRight: "20px",
          // padding: "5px 0px",
          "& >*": {
            margin: "auto",
            marginLeft: "5px"
          }
        },
        "& .r-actions": {
          height: "100%",
          display: "flex",
          "& >*": {
            margin: "auto"
            // height: "100%",
            // width: "38px",
            // minWidth: "38px",
            // padding: "0px",
            // border: "none",
            // borderRadius: "0px"
          }
        }
      }
    }
  },
  table: {
    "& .r-c-check": {
      // padding: "0px !important"
    },
    "& .t-head": {
      "& .h-cell": {
        backgroundColor: '#EE602C',
        color: "#fff",
        padding: "0px 8px",
        // borderRight: "1px solid #fff",
        "& button": {
          color: "#fff",
        },
        "& .chk-all": {
          color: "#fff"
          // "& .MuiIconButton-label": {
          //   color: "#fff"
          // }
        }
      },


      "& .view-align-right": {
        justifyContent: "flex-end !important",
      },

      "& .view-sort": {
        width: '100%',
        display: "flex",
        justifyContent: "space-between",
        textTransform: "capitalize",
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '3px',
        "&:hover": {
          cursor: "pointer"
        }
      },
      "& .view-sorted": {
        width: '100%',
        display: "flex",
        justifyContent: "space-between",
        textTransform: "capitalize",
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '3px',
        "&:hover": {
          cursor: "pointer"
        },

      },
    },
    "& .t-body": {
      // backgroundColor: "rgba(51, 51, 51, 0.1)",
      "& .b-row": {
        "& .r-cell": {
          padding: "4px 8px",
          minHeight: 38,
          // borderRight: "1px solid #fff",
          // borderBottom: "1px solid #fff",
          borderBottom: "0px",
          "& .cell-link": {
            "&:hover": {
              textDecoration: "underline",
              cursor: "pointer"
            }
          },
          "& p, & span": {
            fontSize: 14,
            fontFamily: "'Open Sans', sans-serif !important",
          },
          "& span.MuiTypography-caption": {
            fontSize: "0.75rem",
          },
          fontSize: 14,
          fontFamily: "'Open Sans', sans-serif !important",
        },
        "& .r-c-act": {
          paddingLeft: 0,
          paddingRight: 0
        },
        "& .r-c-no": {
          paddingLeft: "10px"
        },
        "& .r-even": {
          backgroundColor: "rgb(245, 245, 245)"
        },
        "& .r-c-sts": {
          paddingLeft: 0,
          paddingRight: 0
        },
        // "&:hover": {
        //   backgroundColor: "rgba(0,0,0,0.1)"
        // }
      }
    }
  }
}));
